import { getCookie } from '@/utils/cookies';

const orgSearchComponent = {
    fieldType: 'ai-form-text-box-virtual-grid-dictionary',
    extParams: {
        displayExpr: 'name',
        valueExpr: 'kodp',
        keyExpr: 'kodp',
        columns: [
            {field: 'kodp', text: 'kodp', data_type: 'number', visible: false},
            {field: 'sname', text: 'Код', data_type: 'number', visible: true, width: 100},
            {field: 'name', text: 'Наименование', visible: true, width: 350},
            {field: 'str_adr_u', text: 'Адрес юридический', visible: true, width: 400},
            {field: 'str_adr_f', text: 'Адрес местонахождения', visible: true, width: 400},
            {field: 'inn', text: 'ИНН', visible: true, width: 100},
            {field: 'kpp', text: 'КПП', visible: true, width: 100},
            {field: 'ecls', text: 'ecls', visible: false},
            {field: 'name_group', text: 'name_group', visible: false},
        ],
        loadUrl: 'tep-grid./tep/search/org/data/get',
        autoLoadData: false,
        toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save', 'group-area', 'show-column-chooser', 'export']
    }
}

const getITCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let i = 0; i < 4; i++) {
        const groupId = i + 1;
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'name'
            });
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_abon'
            });
            components.push({
                ...orgSearchComponent,
                title: 'Структурное подразделение',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_abon',
                fieldNameText: 'name_strct_podr'
            })
        }
        else if ([2, 3].includes(groupId)) {
            let measurements = '';
            let tarifKod = 0;
            if (groupId === 2) {
                item.label = 'Тариф за возврат конденсата';
                measurements = 'тонны';
                tarifKod = 1;
            } else if (groupId === 3) {
                item.label = 'Тариф за резервирование мощности';
                measurements = 'Гкал/ч';
                tarifKod = 2;
            }
            components.push({
                name: 'tep-tarif',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-tarif',
                metaKod: {
                    title: 'Код',
                    size: [1, 1],
                    fieldNameText: `npp${tarifKod}`,
                    fieldValue: 'npp'
                },
                metaName: {
                    title: 'Наименование тарифа',
                    size: [1, 4],
                    fieldNameId: `tarif${tarifKod}`,
                    fieldNameText: `name_tarif${tarifKod}`, // fieldKey
                    extParams: {
                        displayExpr: `name`,
                        valueExpr: `tarif`
                    }
                },
                metaRate: {
                    title: `Ставка (за ${measurements})`,
                    size: [1, 1],
                    fieldNameText: `rate${tarifKod}`,
                    fieldValue: `rate${tarifKod === 1 ? '2' : '1'}`
                }
            })
        }
        else if (groupId === 4) {
            item.label = 'Температурный график (°C)';
            components.push({
                name: 'tep-search-tmp-graf',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-search-tmp-graf',
                metaName: {
                    title: 'Наименование',
                    fieldNameText: 'name_tg'
                },
                metaT1: {
                    title: 'T1',
                    fieldNameText: 't1'
                },
                metaT2: {
                    title: 'T2',
                    fieldNameText: 't2'
                },
                metaT1sr: {
                    title: 'T1 ср.г.',
                    fieldNameText: 't1_sg'
                },
                metaT2sr: {
                    title: 'T2 ср.г.',
                    fieldNameText: 't2_sg'
                }
            });
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getTV_OtvCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let i = 0; i < 5; i++) {
        const groupId = i + 1;
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Основная';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Тип теплоносителя',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tn_name',
                fieldNameId: 'kod_tn',
            });
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Подразделение ЭС',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'podr_name'
            });
            components.push({
                name: 'tep-tv-table-group',
                groupId: groupId,
                size: [3, 6],
                fieldNameText: 'tep-tv-table-group'
            })
        }
        else if (groupId === 3) {
            item.label = 'Схема присоединения тепловых нагрузок';
            item.icon = '/infoenergo/assets/tep/tep-cards/nagr-system.svg';
            for (let j = 1; j <= 3; j++) {
                let f = '';
                let tip = '';
                let nameView = '';
                let short ='';
                if (j === 1) {
                    f = 'so';
                    tip = 'отопления';
                    short = 'CO';
                    nameView = 'qs-sxpr-so';
                }
                else if (j === 2) {
                    f = 'sw';
                    tip = 'вентиляции и кондиционирования';
                    short = 'CВ';
                    nameView = 'qs-sxpr-sw';
                }
                else if (j === 3) {
                    f = 'gw';
                    tip = 'горячего водоснабжения';
                    short = 'ГВС';
                    nameView = 'qs-sxpr-qw';
                }
                components.push({
                    name: 'tep-nagr-system',
                    groupId: groupId,
                    size: [1, 5],
                    fieldNameText: `kod_sxp_${f}`,
                    flexWrap: true,
                    metaScheme: {
                        title: `Система ${tip}`,
                        fieldMeta: {
                            title: '',
                            fieldNameText: `kod_sxp_${f}_name`,
                            fieldNameId: `kod_sxp_${f}`,
                            gridId: `kod_t${f}`,
                        },
                        popupData: {
                            title: `${short}`,
                            view: `${nameView}-view`
                        },
                        showKis: f !== 'sw'
                    }
                })
            }
        }
        else if (groupId === 4) {
            item.label = 'Граница';
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'балансовой принадлежности',
                fieldNameText: 'gr_balans',
                flexWrap: true
            })
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'эксплуатационной ответственности',
                fieldNameText: 'gr_ekspl',
                flexWrap: true
            })
        }
        else if (groupId === 5) {
            item.label = 'Принадлежность и обслуживание';
            components.push({
                ...orgSearchComponent,
                title: 'Балансовая принадлежность',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_abon',
                fieldNameText: 'name_abon'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_abon'
            });
            components.push({
                ...orgSearchComponent,
                title: 'Техническое обслуживание',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_to',
                fieldNameText: 'name_to'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_to'
            });
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getPVCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let i = 0; i < 4; i++) {
        const groupId = i + 1;
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Характеристика пара';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Тип теплоносителя',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'tn_name',
                fieldNameId: 'kod_tn',
            });
            components.push({
                name: 'tep-pv-harp-par',
                title: 'Характеристика пара',
                groupId: groupId,
                size: [1, 4],
                fieldNameText: 'harp_name',
                fieldNameId: 'kod_harp',
            });
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-1',
                ch: 'Давление пара',
                chM: 'ата',
                chField: 'p_p',
                chFieldFrom: 'p_ot',
                chFieldTo: 'p_do',
            });
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-2',
                ch: 'Температура пара у теплоисточника',
                chM: '°C',
                chField: 'p_t',
                chFieldFrom: 't_ot',
                chFieldTo: 't_do'
            });
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'Теплосодержание пара у источника тепла [Ккал/кг]',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'ts',
                readOnly: true,
                empty: true,
            });
            components.push({
                name: 'tep-pv-calc-button',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-pv-calc-button'
            });
        }
        else if (groupId === 3) {
            item.label = 'Граница';
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'балансовой принадлежности',
                fieldNameText: 'gr_balans',
                flexWrap: true
            })
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'эксплуатационной ответственности',
                fieldNameText: 'gr_ekspl',
                flexWrap: true
            })
        }
        else if (groupId === 4) {
            item.label = 'Принадлежность и обслуживание';
            components.push({
                ...orgSearchComponent,
                title: 'Балансовая принадлежность',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_abon',
                fieldNameText: 'name_abon'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_abon'
            });
            components.push({
                ...orgSearchComponent,
                title: 'Техническое обслуживание',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_to',
                fieldNameText: 'name_to'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_to'
            });
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getOtvPCardMeta = async (params) => {
    const meta = {
        groups: [{
            id: 1,
            label: params.cardName,
            icon: `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`,
            collapsed: false
        }],
        components: []
    }
    meta.components.push({
        fieldType: 'ai-form-text-box-readonly',
        title: 'Источник',
        groupId: 1,
        size: [1, 6],
        fieldNameText: 'path'
    });
    meta.components.push({
        fieldType: 'ai-form-text-box',
        title: 'Наименование',
        groupId: 1,
        size: [1, 6],
        fieldNameText: 'name'
    });
    return meta;
}

const getTC_OdpuCardMeta = async (params) => {
    const meta = {
        groups: [{
            id: 1,
            label: params.cardName,
            icon: `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`,
            collapsed: false
        }],
        components: []
    }
    meta.components.push({
        fieldType: 'ai-form-text-box-readonly',
        title: 'Источник',
        groupId: 1,
        size: [1, 6],
        fieldNameText: 'path'
    });
    meta.components.push({
        fieldType: 'ai-form-text-box',
        title: 'Наименование',
        groupId: 1,
        size: [1, 6],
        fieldNameText: 'name'
    });
    meta.components.push({
        fieldType: 'ai-form-text-box-readonly',
        title: 'Тип теплоносителя',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'tn_name',
        fieldNameId: 'kod_tn',
    });
    meta.components.push({
        fieldType: 'ai-form-number-box',
        title: '№',
        groupId: 1,
        size: [1, 1],
        fieldNameText: 'nn',
        empty: true,
    });
    if (params.kod_vid === 42) {
        meta.components.push({
            fieldType: 'ai-form-check-box',
            title: 'Суммировать показания ОПУ в межотопительный сезон',
            groupId: 1,
            size: [1, 6],
            fieldNameText: 'pr_sum_opu'
        });
    }
    return meta;
}

const getAVCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    const groupNumber = params.kod_vid === 50 ? 6 : 9
    for (let groupId = 1; groupId <= groupNumber; groupId++) {
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Параметры';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Тип теплоносителя',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'tn_name',
                fieldNameId: 'kod_tn',
            });
            components.push({
                fieldType: 'ai-form-select-box',
                title: 'Эксплуатационный район',
                groupId: groupId,
                size: [1, 2],
                // перепутаны в компоненте эти поля
                fieldNameId: 'name_reg',
                fieldNameText: 'kod_reg',
                showClearButton: true,
                extParams: {
                    displayExpr: 'name',
                    valueExpr: 'kod',
                    dictionaryRoutePath: 'tep-grid./tep/lookup-expl-raion/get',
                }
            });
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Подразделение ЭС',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'podr_name'
            });
        }
        else if (groupId === 3 && params.kod_vid === 55) {
            item.label = 'Адреса';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Адрес',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'name_adr1'
            });
            // Заготовка на будущее, пока пользуемся readonly компонентом
            /* components.push({
                fieldType: 'ai-form-text-box-virtual-grid-dictionary',
                title: 'Адрес',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'name_adr1',
                fieldNameText: 'name_adr1', // fieldKey
                extParams: {
                    displayExpr: 'name',
                    valueExpr: 'kod',
                    apiGetList: 'tep_grid./tep/...-list/get',
                    name: '',
                    keyExpr: 'kod'
                }
            }); */
            components.push({
                name: 'tep-av-add-address-btn',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-av-add-address-btn',
                fieldsMeta: {
                    addressField: 'kod_adr1',
                    nameField: 'name'
                }
            });
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Строительный адрес',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'name_adr2'
            });
        }
        else if (groupId === 3 && params.kod_vid === 50 || groupId === 4 && params.kod_vid === 55) {
            item.label = 'Граница';
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'балансовой принадлежности',
                fieldNameText: 'gr_balans',
                flexWrap: true
            })
            components.push({
                fieldType: 'ai-form-multiline-text-box',
                groupId: groupId,
                size: [1, 6],
                title: 'эксплуатационной ответственности',
                fieldNameText: 'gr_ekspl',
                flexWrap: true
            })
        }
        else if (groupId === 4 && params.kod_vid === 50 || groupId === 5 && params.kod_vid === 55) {
            item.label = 'Принадлежность и обслуживание';
            components.push({
                ...orgSearchComponent,
                title: 'Балансовая принадлежность',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_abon',
                fieldNameText: 'name_abon'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_abon'
            });
            components.push({
                ...orgSearchComponent,
                title: 'Техническое обслуживание',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_to',
                fieldNameText: 'name_to'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_to'
            });
        }
        else if (groupId === 5 && params.kod_vid === 50 || groupId === 6 && params.kod_vid === 55) {
            item.label = 'Договор';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: '',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'ndog'
            });
        }
        else if (groupId === 6 && params.kod_vid === 50) {
            item.label = 'Коэффициенты использования';
            components.push({
                name: 'tep-av-system-choice',
                title: 'Система отопления',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'pr_so',
                fieldNameKis: 'so'
            });
            components.push({
                name: 'tep-av-system-choice',
                title: 'Система горячего водоснабжения',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'pr_gw',
                fieldNameKis: 'gvs'
            });
        }
        else if (groupId === 7 && params.kod_vid === 55) {
            item.label = 'Расчет температуры';
            // row 1
            components.push({
                name: 'tep-only-title',
                title: 'Температура наружного воздуха',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-only-title-1'
            });
            for (let i = 0; i < 2; i++) {
                let title = '';
                let f = '';
                if (i === 0) {
                    title = 'СО';
                    f = 'so';
                } else if (i === 1) {
                    title = 'СВ';
                    f = 'sw';
                }
                components.push({
                    fieldType: 'ai-form-select-box',
                    title: title,
                    groupId: groupId,
                    size: [1, 2],
                    fieldNameId: `tnv_${f}`,
                    fieldNameText: `tnv_${f}`,
                    showClearButton: true,
                    extParams: {
                        displayExpr: 'tnv',
                        valueExpr: 'tnv',
                        dictionaryRoutePath: 'tep-grid./tep/lookup-tnv-values/get',
                    }
                });
            }
            // row 2
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Характеристики пара',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'harp_name',
                fieldNameId:'kod_harp',
            });
            // row 3
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-1',
                ch: 'Давление у источника',
                chM: 'ата',
                chField: 'p_p',
                chFieldFrom: 'p_ot',
                chFieldTo: 'p_do',
                readOnly: true
            });
            // row 4
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-2',
                ch: 'Температура у источника',
                chM: '°C',
                chField: 'p_ti',
                chFieldFrom: 'ti_ot',
                chFieldTo: 'ti_do',
                readOnly: true
            });
            // row 5
            components.push({
                fieldType: 'ai-form-number-box-readonly',
                title: 'Теплосодержание пара у источника тепла [Ккал/кг]',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'tsi'
            });
            // row 6
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-3',
                ch: 'Давление на ГР',
                chM: 'ата',
                chField: 'p_pa',
                chFieldFrom: 'pa_ot',
                chFieldTo: 'pa_do'
            });
            // row 7
            components.push({
                name: 'tep-pv-characteristics',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-pv-characteristics-4',
                ch: 'Температура на ГР',
                chM: '°C',
                chField: 'p_ta',
                chFieldFrom: 'ta_ot',
                chFieldTo: 'ta_do'
            });
            // row 8
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'Теплосодержание пара на ГР [Ккал/кг]',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'tsa',
                readOnly: true,
                empty: true,
            });
            components.push({
                name: 'tep-pv-calc-button',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'tep-pv-calc-button'
            });
            // row 9
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'Темп. конд. [°C]',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'p_tk',
            });
            components.push({
                fieldType: 'ai-form-number-box-readonly',
                title: 'Средний % возвр. конден.',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'srvoz'
            });
            components.push({
                fieldType: 'ai-form-check-box-readonly',
                title: 'Не возвр.',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'srvoz_flag'
            });
            // row 10
            components.push({
                name: 'tep-only-title',
                title: 'Мин. доп. расход пара<br>[т/час]',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-only-title-2'
            });
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'ОС',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'gmin',
            });
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'МОС',
                groupId: groupId,
                size: [1, 2],
                fieldNameText: 'gmin_mos',
            });
        }
        else if (groupId === 8 && params.kod_vid === 55) {
            item.label = 'Схемы присоединения / КПД теплообменников';
            item.icon = '/infoenergo/assets/tep/tep-cards/nagr-system.svg';
            for (let j = 1; j <= 4; j++) {
                let f = '';
                let tip = '';
                let nameView = '';
                if (j === 1) {
                    f = 'so';
                    tip = 'СО';
                    nameView='qs-sxpr-sop';
                }
                else if (j === 2) {
                    f = 'sw';
                    tip = 'СВ';
                    nameView='qs-sxpr-swp';
                }
                else if (j === 3) {
                    f = 'st';
                    tip = 'СТ';
                    nameView='qs-sxpr-stp';
                }
                else if (j === 4) {
                    f = 'gw';
                    tip = 'ГВС';
                    nameView='qs-sxpr-gwp';
                }
                components.push({
                    name: 'tep-nagr-system',
                    groupId: groupId,
                    size: [1, 6],
                    fieldNameText: `tep_nagr_system_${f}`,
                    metaScheme: {
                        title: `Система ${tip}`,
                        fieldMeta: {
                            title: '',
                            fieldNameId: `kod_sxp_${f}p`,
                            fieldNameText: `sxp_${f}`
                        },
                        kpdMeta: {
                            title: '',
                            fieldNameText: `kpd_${f}`
                        },
                        popupData: {
                            title: `${tip}`,
                            view: `${nameView}-view`
                        },
                        showKis: f !== 'sw',
                        showKpd: true
                    }
                })
            }
        }
        else if (groupId === 9 && params.kod_vid === 55) {
            item.label = 'Возв. конденсат';
            components.push({
                name: 'tep-av-grid',
                groupId: groupId,
                size: [5, 3],
                fieldNameText: 'tep-av-grid'
            })
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getOpu_UuCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    const dep = +getCookie('dep');

    for (let groupId = 1; groupId <= 3; groupId++) {
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'name'
            });
            components.push({
                fieldType: 'ai-form-number-box',
                title: 'Код АСКУТЭ',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'kod_askute',
                empty: true,
            });
            if (params.kod_vid === 22210000) {
                // для ОПУ
                components.push({
                    fieldType: 'ai-form-text-box-readonly',
                    title: 'Адрес',
                    groupId: groupId,
                    size: [1, 5],
                    fieldNameText: 'name_adr'
                });
                // В разработке
                // components.push({
                //     fieldType: 'ai-form-text-box-virtual-grid-dictionary',
                //     title: 'Адрес',
                //     groupId: groupId,
                //     size: [1, 5],
                //     fieldNameId: 'name_adr1',
                //     fieldNameText: 'name_adr1',
                //     extParams: {
                //         displayExpr: 'name',
                //         valueExpr: 'kod',
                //         apiGetList: 'tep_grid./tep/...-list/get',
                //         name: '',
                //         keyExpr: 'kod'
                //     }
                // });
                components.push({
                    name: 'tep-address-nsi-button',
                    groupId: groupId,
                    size: [1, 1],
                    fieldNameText: 'tep-address-nsi-button',
                    treeItemData: params
                });
            } else {
                components.push({
                    fieldType: 'ai-form-text-box-readonly',
                    title: 'Адрес',
                    groupId: groupId,
                    size: [1, 6],
                    fieldNameText: 'name_adr'
                });
            }
        }
        else if (groupId === 2) {
            item.label = 'СИ';
            components.push({
                name: 'tep-opu-si-grid',
                groupId: groupId,
                size: [5, 6],
                fieldNameText: 'tep-opu-si-grid',
            })
        }
        else if (groupId === 3) {
            item.label = 'Параметры';
            components.push({
                name: 'tep-opu-parameters-row',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-opu-parameters-row',
                statusField: 'pr_active',
                dogVisible: params.kod_vid === 22210000, // только для ОПУ
                nDogMeta: {
                    fieldNameText: 'ndog',
                    title: 'Номер договора',
                },
                // Заготовка на будущее, пока пользуемся readonly компонентом
                // selectBoxMeta: {
                //     fieldNameId: 'kod_dog',
                //     fieldNameText: 'ndog',
                //     title: 'Номер договора',
                //     showClearButton: true,
                //     extParams: {
                //         displayExpr: 'name',
                //         valueExpr: 'kod',
                //         dictionaryRoutePath: 'tep_grid./tep/...-list/get',
                //     }
                // },
                radioMeta: {
                    // title: 'Показать',
                    fieldNameText: 'prib_flag',
                    extParams: {
                        displayExpr: 'title',
                        valueExpr: 'field',
                        layout: 'horizontal',
                        items: [
                            {title: 'Показать действ. приборы', field: 'active_prib'},
                            {title: 'Показать все приборы', field: 'all_prib'}
                        ]
                    }
                },
            });
            components.push({
                name: 'tep-only-title',
                title: 'Коммерческий учет',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-only-title-1'
            });
            components.push({
                fieldType: dep === 102276625 ?'ai-form-date-box' :'ai-form-date-box-readonly',
                title: 'Дата начала',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'data_komu_uu',
            });
            components.push({
                fieldType: dep === 102276625 ?'ai-form-date-box' :'ai-form-date-box-readonly',
                title: 'Дата окончания',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'data_okon_uu',
            });
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: '',
                groupId: groupId,
                size: [1, 3],
                fieldNameText: 'odpu'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Место установки',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'mesto_uu'
            });
            components.push({
                ...orgSearchComponent,
                title: 'Обслуживающая организация',
                groupId: groupId,
                size: [1, 5],
                fieldNameId: 'kod_to_uu',
                fieldNameText: 'name_to_uu'
            })
            components.push({
                name: 'tep-officials-button',
                groupId: groupId,
                size: [0, 0],
                fieldNameText: 'tep-officials-button',
                treeItemData: params,
                fieldKodOrg: 'kod_to_uu'
            });
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getCtpCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let groupId = 1; groupId <= 2; groupId++) {
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Адрес';
            components.push({
                name: 'tep-ctp-address-row',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'tep-ctp-address-row',
                radioMeta: {
                    fieldNameText: 'pr_stream',
                    extParams: {
                        displayExpr: 'title',
                        valueExpr: 'value',
                        layout: 'horizontal',
                        items: [
                            {title: 'Отопление', value: 0},
                            {title: 'ГВС', value: 1}
                        ]
                    }
                }
            })
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getAuprCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let groupId = 1; groupId <= 2; groupId++) {
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Информация';
            components.push({
                name: 'tep-aupr-grid',
                groupId: groupId,
                size: [6, 6],
                fieldNameText: 'tep-aupr-grid',
            });
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getItpCardMeta = async (params) => {
    const meta = {groups: [], components: []}
    for (let groupId = 1; groupId <= 5; groupId++) {
        const item = {
            id: groupId,
            label: '',
            collapsed: false
        }
        const components = [];
        if (groupId === 1) {
            item.icon = `/infoenergo/assets/tep/tep-tree/kod_vid_${params.kod_vid}.svg`;
            item.label = params.cardName;
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Источник',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'path'
            });
            components.push({
                fieldType: 'ai-form-text-box',
                title: 'Наименование',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'name'
            });
        }
        else if (groupId === 2) {
            item.label = 'Адреса';
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Адрес',
                groupId: groupId,
                size: [1, 5],
                fieldNameText: 'name_adr'
            });
            // Заготовка на будущее, пока пользуемся readonly компонентом
            // components.push({
            //     fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            //     title: 'Адрес',
            //     groupId: groupId,
            //     size: [1, 5],
            //     fieldNameId: 'tep_address',
            //     fieldNameText: 'tep_address', // fieldKey
            //     extParams: {
            //         displayExpr: 'name',
            //         valueExpr: 'kod',
            //         apiGetList: 'tep_grid./tep/...-list/get',
            //         name: '',
            //         keyExpr: 'kod'
            //     }
            // });
            components.push({
                name: 'tep-itp-address-buttons',
                groupId: groupId,
                size: [1, 1],
                fieldNameText: 'tep-itp-address-buttons',
                fieldsMeta: {
                    addressField: 'kod_adr1',
                    nameField: 'name'
                },
                treeItemData: params
            });
            components.push({
                fieldType: 'ai-form-text-box-readonly',
                title: 'Строительный адрес',
                groupId: groupId,
                size: [1, 6],
                fieldNameText: 'kod_adr3'
            });
        }
        else if (groupId === 3) {
            item.label = 'Температурные режимы';
            components.push({
                name: 'tep-tv-table-group',
                groupId: groupId,
                size: [3, 6],
                fieldNameText: 'tep-tv-table-group'
            });
        }
        else if (groupId === 4) {
            item.label = 'Расчет потерь воды';
            components.push({
                name: 'tep-itp-rasch-pot',
                groupId: groupId,
                size: [2, 6],
                fieldNameText: 'tep-itp-rasch-pot',
                radioMeta: {
                    fieldNameText: 'pr_pgst',
                    extParams: {
                        displayExpr: 'title',
                        valueExpr: 'field',
                        layout: 'horizontal',
                        items: [
                            {title: 'По нагрузке', field: 1 },
                            {title: 'По емкости', field: 2 },
                            {title: 'По нагрузке и приборам', field: 3}
                        ]
                    }
                },
                selectMeta: {
                    title: 'Тип здания',
                    fieldNameText: 'k_pg',
                    fieldNameId: 'k_pg_name',
                    showClearButton: false,
                    extParams: {
                        displayExpr: 'name',
                        valueExpr: 'kod',
                        dictionaryRoutePath: 'tep-grid./tep/lookup-itp-tip-zd/get',
                    }
                },
                soMeta: {
                    title: 'Объем СО [л]',
                    fieldNameText: 'v_so',
                    dataType: 'number',
                },
                swMeta: {
                    title: 'Объем СВ [л]',
                    fieldNameText: 'v_sw',
                    dataType: 'number',
                }
            });
        }
        else if (groupId === 5) {
            item.label = 'Схема присоединения тепловых нагрузок';
            item.icon = '/infoenergo/assets/tep/tep-cards/nagr-system.svg';
            for (let j = 1; j <= 3; j++) {
                let f = '';
                let tip = '';
                let nameView = '';
                let short ='';
                let checkBoxItem = null;
                if (j === 1) {
                    f = 'so';
                    tip = 'отопления';
                    short ='СО';
                    nameView = 'qs-sxpr-so';
                }
                else if (j === 2) {
                    f = 'sw';
                    tip = 'вентиляции и кондиционирования';
                    short ='СВ';
                    nameView = 'qs-sxpr-sw';
                    checkBoxItem = {
                        title: 'Общая система отопления',
                        fieldNameText: 'pr_sxpsw'
                    };
                }
                else if (j === 3) {
                    f = 'gw';
                    tip = 'горячего водоснабжения';
                    short ='ГВС';
                    nameView = 'qs-sxpr-qw';
                    checkBoxItem = {
                        title: 'Наличие бака-аккумулятора',
                        fieldNameText: 'nal_bak'
                    };
                }
                components.push({
                    name: 'tep-nagr-system',
                    groupId: groupId,
                    size: [1, 5],
                    fieldNameText: `kod_sxp_${f}`,
                    metaScheme: {
                        title: `Система ${tip}`,
                        fieldMeta: {
                            title: '',
                            fieldNameText: `kod_sxp_${f}_name`,
                            fieldNameId:  `kod_sxp_${f}`,
                            gridId: `kod_t${f}`,
                        },
                        popupData: {
                            title: `${short}`,
                            view: `${nameView}-view`
                        },
                        showKis: f !== 'sw',
                        checkBox: checkBoxItem
                    }
                })
            }
        }
        meta.groups.push(item);
        meta.components.push(...components);
    }
    return meta;
}

const getCardMeta = async (params) => {
    let result = null;
    if (params.kod_vid === 10) {
        result = await getITCardMeta(params);
    } else if ([20, 30].includes(params.kod_vid)) {
        result = await getTV_OtvCardMeta(params);
    } else if (params.kod_vid === 25) {
        result = await getPVCardMeta(params);
    } else if (params.kod_vid === 35) {
        result = await getOtvPCardMeta(params);
    } else if ([40, 41, 42, 45, 46].includes(params.kod_vid)) {
        result = await getTC_OdpuCardMeta(params);
    } else if ([50, 55].includes(params.kod_vid)) {
        result = await getAVCardMeta(params);
    } else if ([22200000, 22210000, 32200000].includes(params.kod_vid)) {
        result = await getOpu_UuCardMeta(params);
    } else if (params.kod_vid === 22550000) {
        result = await getCtpCardMeta(params);
    } else if (params.kod_vid === 32240000) {
        result = await getAuprCardMeta(params);
    } else if (params.kod_vid === 22510000) {
        result = await getItpCardMeta(params);
    }
    if (result) result.inner = true;
    return result;
}

export default getCardMeta;
